import React from 'react';
import PropTypes from 'prop-types';

const ChevronUp = ({color = 'currentColor', ...props}) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.833008 5.15287L5.00035 1.33334L9.16634 5.15287"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

ChevronUp.propTypes = {
  color: PropTypes.string,
};

export default ChevronUp;
